<template>
  <div>
    <div ref="flyawayMWL">
      <!-- so named because it will fly away to another component -->
      <slot> </slot>
    </div>
  </div>
</template>

<script>
export default (x => {
  return x.default || x;
  // tslint:disable-next-line
})(require("./GMMWLInfoWindow.js"));
</script>
